import React, { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaTrash, FaCheck, FaStream } from "react-icons/fa";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Editor from '@monaco-editor/react';
import Paginacao from '../../common/pagination';

class ClienteIntegracaoHiPlatform extends Component {
    constructor(props) {
        super(props);

        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listIntegracoes: [],
            loading: true,
            loadingModal: false,
            error: '',
            page_numb: 1,
            
            // Programas para o select
            programas: [],
            loadingProgramas: false,

            // Modal Integração
            showModal: false,
            modalTitulo: '',
            
            // Campos do formulário
            id: null,
            url_api: '',
            sufixo_nome_template: '',
            usuario_api: '',
            usuario_senha: '',
            config_id: '',
            namespace: '',
            ativo: true,
            programa_id: '',
            templates: [],
            
            // Erros de validação
            url_apiError: '',
            usuario_apiError: '',
            usuario_senhaError: '',
            config_idError: '',
            namespaceError: '',

            // Modal Templates
            showModalTemplates: false,
            integracaoSelecionada: null,
            templatesJson: '[]',
            templatesJsonError: '',
        };
    }

    componentDidMount() {
        this.carregarIntegracoes(this.state.page_numb);
        this.carregarProgramas();
    }

    carregarIntegracoes = (page_numb = 1) => {
        const { clienteId } = this.props;

        if (!clienteId) {
            this.setState({ loading: false, error: 'ID do cliente não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        api.get(`/integracao/hiplatform/?cliente_id=${clienteId}&page=${page_numb}`)
            .then(response => {
                this.setState({
                    listIntegracoes: response.data,
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao carregar integrações HiPlatform';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg,
                });
            });
    };

    carregarProgramas = () => {
        const { clienteId } = this.props;

        this.setState({ loadingProgramas: true });

        api.get(`/programas/?cliente_id=${clienteId}&page_size=100`)
            .then(response => {
                this.setState({
                    programas: response.data.results || [],
                    loadingProgramas: false,
                });
            })
            .catch(error => {
                console.error('Erro ao carregar programas:', error);
                this.setState({ loadingProgramas: false });
            });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.carregarIntegracoes(num_page);
    }

    getProgramaNome = (programa_id) => {
        if (!programa_id) return '-';
        const programa = this.state.programas.find(p => p.id === programa_id);
        return programa ? programa.nome : '-';
    };

    abrirModalNovo = () => {
        this.setState({
            showModal: true,
            modalTitulo: 'Adicionar Integração HiPlatform',
            id: null,
            url_api: '',
            sufixo_nome_template: '',
            usuario_api: '',
            usuario_senha: '',
            config_id: '',
            namespace: '',
            ativo: true,
            programa_id: '',
            templates: [],
            url_apiError: '',
            usuario_apiError: '',
            usuario_senhaError: '',
            config_idError: '',
            namespaceError: '',
        });
    };

    abrirModalEditar = (integracao) => {
        this.setState({
            showModal: true,
            modalTitulo: 'Editar Integração HiPlatform',
            id: integracao.id,
            url_api: integracao.url_api || '',
            sufixo_nome_template: integracao.sufixo_nome_template || '',
            usuario_api: integracao.usuario_api || '',
            usuario_senha: integracao.usuario_senha || '',
            config_id: integracao.config_id || '',
            namespace: integracao.namespace || '',
            ativo: integracao.ativo !== undefined ? integracao.ativo : true,
            programa_id: integracao.programa_id || '',
            templates: integracao.templates || [],
            url_apiError: '',
            usuario_apiError: '',
            usuario_senhaError: '',
            config_idError: '',
            namespaceError: '',
        });
    };

    fecharModal = () => {
        this.setState({
            showModal: false,
            id: null,
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, [`${name}Error`]: '' });
    };

    handleAtivoChange = (valor) => {
        this.setState({ ativo: valor });
    };

    validarFormulario = () => {
        let valido = true;

        if (!this.state.url_api.trim()) {
            this.setState({ url_apiError: 'URL da API é obrigatória' });
            valido = false;
        }

        if (!this.state.usuario_api.trim()) {
            this.setState({ usuario_apiError: 'Usuário API é obrigatório' });
            valido = false;
        }

        if (!this.state.usuario_senha.trim()) {
            this.setState({ usuario_senhaError: 'Senha API é obrigatória' });
            valido = false;
        }

        if (!this.state.config_id.trim()) {
            this.setState({ config_idError: 'Config ID é obrigatório' });
            valido = false;
        }

        if (!this.state.namespace.trim()) {
            this.setState({ namespaceError: 'Namespace é obrigatório' });
            valido = false;
        }

        return valido;
    };

    salvar = async () => {
        if (!this.validarFormulario()) {
            return;
        }

        const { clienteId } = this.props;
        const { 
            id, 
            url_api, 
            sufixo_nome_template, 
            usuario_api, 
            usuario_senha, 
            config_id, 
            namespace, 
            ativo, 
            programa_id,
            templates 
        } = this.state;

        this.setState({ loadingModal: true });

        const dados = {
            cliente_id: clienteId,
            url_api,
            sufixo_nome_template: sufixo_nome_template || '',
            usuario_api,
            usuario_senha,
            config_id,
            namespace,
            ativo,
            programa_id: programa_id || null,
            templates: templates || [],
        };

        const url = id ? `/integracao/hiplatform/${id}/` : '/integracao/hiplatform/';
        const metodo = id ? 'put' : 'post';

        try {
            await api({
                method: metodo,
                url: url,
                data: dados,
            });

            const MySwal = withReactContent(Swal);
            const textSwal = id ? 'Integração atualizada com sucesso' : 'Integração cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ loadingModal: false });
            this.fecharModal();
            this.carregarIntegracoes(this.state.page_numb);

        } catch (error) {
            let erro_msg = 'Erro ao salvar integração, verifique os campos e tente novamente';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                
                if (campos.url_api) this.setState({ url_apiError: campos.url_api });
                if (campos.usuario_api) this.setState({ usuario_apiError: campos.usuario_api });
                if (campos.usuario_senha) this.setState({ usuario_senhaError: campos.usuario_senha });
                if (campos.config_id) this.setState({ config_idError: campos.config_id });
                if (campos.namespace) this.setState({ namespaceError: campos.namespace });
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });

            this.setState({ loadingModal: false });
        }
    };

    excluir = (integracao) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Você tem certeza?',
            text: 'Esta ação não pode ser desfeita!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await api.delete(`/integracao/hiplatform/${integracao.id}/`);

                    MySwal.fire(
                        'Excluído!',
                        'Integração excluída com sucesso.',
                        'success'
                    );

                    this.carregarIntegracoes(this.state.page_numb);

                } catch (error) {
                    let erro_msg = 'Erro ao excluir integração';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: erro_msg,
                    });
                }
            }
        });
    };

    // ==================== TEMPLATES ====================

    abrirModalTemplates = (integracao) => {
        this.setState({
            showModalTemplates: true,
            integracaoSelecionada: integracao,
            templatesJson: integracao.templates ? JSON.stringify(integracao.templates, null, 4) : '[]',
            templatesJsonError: '',
        });
    };

    fecharModalTemplates = () => {
        this.setState({
            showModalTemplates: false,
            integracaoSelecionada: null,
            templatesJson: '[]',
            templatesJsonError: '',
        });
    };

    handleTemplatesJsonChange = (value) => {
        this.setState({ templatesJson: value || '', templatesJsonError: '' });
    };

    salvarTemplates = async () => {
        const { integracaoSelecionada, templatesJson } = this.state;

        // Validar JSON
        let parsedJson;
        try {
            parsedJson = JSON.parse(templatesJson);
        } catch (e) {
            this.setState({ templatesJsonError: 'JSON inválido. Verifique a sintaxe.' });
            return;
        }

        this.setState({ loadingModal: true });

        try {
            await api.put(`/integracao/hiplatform/${integracaoSelecionada.id}/`, {
                cliente_id: integracaoSelecionada.cliente_id,
                url_api: integracaoSelecionada.url_api,
                sufixo_nome_template: integracaoSelecionada.sufixo_nome_template || '',
                usuario_api: integracaoSelecionada.usuario_api,
                usuario_senha: integracaoSelecionada.usuario_senha,
                config_id: integracaoSelecionada.config_id,
                namespace: integracaoSelecionada.namespace,
                ativo: integracaoSelecionada.ativo,
                programa_id: integracaoSelecionada.programa_id || null,
                templates: parsedJson,
            });

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: <p>Templates salvos com sucesso</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ loadingModal: false });
            this.fecharModalTemplates();
            this.carregarIntegracoes(this.state.page_numb);

        } catch (error) {
            let erro_msg = 'Erro ao salvar templates';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });

            this.setState({ loadingModal: false });
        }
    };

    renderRows = () => {
        if ('results' in this.state.listIntegracoes && this.state.listIntegracoes.results.length > 0) {
            return this.state.listIntegracoes.results.map((integracao) => (
                <tr key={integracao.id}>
                    <td>{integracao.id}</td>
                    <td>{this.getProgramaNome(integracao.programa_id)}</td>
                    <td>{integracao.namespace}</td>
                    <td>
                        <span className={`badge ${integracao.ativo ? 'bg-success' : 'bg-secondary'}`}>
                            {integracao.ativo ? 'Ativo' : 'Inativo'}
                        </span>
                    </td>
                    <td>
                        <Button 
                            variant="info" 
                            size="sm" 
                            className="me-1"
                            onClick={() => this.abrirModalTemplates(integracao)}
                            title="Gerenciar Templates"
                        >
                            <FaStream /> Templates
                        </Button>
                        <Button 
                            variant="light" 
                            size="sm" 
                            className="me-1"
                            onClick={() => this.abrirModalEditar(integracao)}
                        >
                            <FaRegEdit /> Editar
                        </Button>
                        <Button 
                            variant="danger" 
                            size="sm"
                            onClick={() => this.excluir(integracao)}
                        >
                            <FaTrash />
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={5}>Nenhuma integração HiPlatform cadastrada para este cliente</td>
            </tr>
        );
    };

    render() {
        const { 
            loading, 
            loadingModal,
            error, 
            listIntegracoes,
            page_numb,
            showModal,
            modalTitulo,
            url_api,
            sufixo_nome_template,
            usuario_api,
            usuario_senha,
            config_id,
            namespace,
            ativo,
            programa_id,
            url_apiError,
            usuario_apiError,
            usuario_senhaError,
            config_idError,
            namespaceError,
            programas,
            loadingProgramas,
            showModalTemplates,
            integracaoSelecionada,
            templatesJson,
            templatesJsonError,
        } = this.state;

        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h4>Integrações HiPlatform</h4>
                            </Col>
                            <Col sm={6} lg={6} className="text-end">
                                <Button variant="secondary" size="sm" onClick={this.abrirModalNovo}>
                                    <FaPlus /> Adicionar Integração
                                </Button>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Programa</th>
                                    <th>Namespace</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={5}>Carregando...</td>
                                    </tr>
                                ) : (
                                    error ? (
                                        <tr>
                                            <td colSpan={5}>{error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>

                        {'results' in listIntegracoes && listIntegracoes.results.length > 0 && 
                            <Paginacao 
                                dados={listIntegracoes} 
                                loading={loading} 
                                page_numb={page_numb} 
                                _onClickPagina={this.onClickPagina} 
                            />
                        }
                    </Card.Body>
                </Card>

                {/* Modal Cadastro/Edição */}
                <Modal 
                    show={showModal} 
                    onHide={this.fecharModal}
                    size="lg"
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa (opcional)</Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="programa_id"
                                            value={programa_id}
                                            onChange={this.handleChange}
                                            disabled={loadingProgramas}
                                        >
                                            <option value="">
                                                {loadingProgramas ? 'Carregando programas...' : 'Selecione um programa (opcional)'}
                                            </option>
                                            {programas.map(programa => (
                                                <option key={programa.id} value={programa.id}>
                                                    {programa.nome}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={8}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>URL da API <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="url_api"
                                            value={url_api}
                                            onChange={this.handleChange}
                                            placeholder="URL da API"
                                        />
                                        {url_apiError && (
                                            <Form.Text className="text-danger">{url_apiError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Sufixo para Template</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="sufixo_nome_template"
                                            value={sufixo_nome_template}
                                            onChange={this.handleChange}
                                            placeholder="Sufixo"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Usuário API <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            type="password" 
                                            name="usuario_api"
                                            value={usuario_api}
                                            onChange={this.handleChange}
                                            placeholder="Usuário"
                                        />
                                        {usuario_apiError && (
                                            <Form.Text className="text-danger">{usuario_apiError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Senha API <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            type="password" 
                                            name="usuario_senha"
                                            value={usuario_senha}
                                            onChange={this.handleChange}
                                            placeholder="Senha"
                                        />
                                        {usuario_senhaError && (
                                            <Form.Text className="text-danger">{usuario_senhaError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Config ID <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            type="password" 
                                            name="config_id"
                                            value={config_id}
                                            onChange={this.handleChange}
                                            placeholder="Config ID"
                                        />
                                        {config_idError && (
                                            <Form.Text className="text-danger">{config_idError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Namespace <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="namespace"
                                            value={namespace}
                                            onChange={this.handleChange}
                                            placeholder="Namespace"
                                        />
                                        {namespaceError && (
                                            <Form.Text className="text-danger">{namespaceError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Status</Form.Label>
                                        <div>
                                            <Button
                                                variant={ativo ? "success" : "outline-secondary"}
                                                onClick={() => this.handleAtivoChange(true)}
                                                className="me-2"
                                            >
                                                Ativo
                                            </Button>
                                            <Button
                                                variant={!ativo ? "danger" : "outline-secondary"}
                                                onClick={() => this.handleAtivoChange(false)}
                                            >
                                                Inativo
                                            </Button>
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModal}>
                            Cancelar
                        </Button>
                        <Button 
                            variant="success" 
                            onClick={this.salvar}
                            disabled={loadingModal}
                        >
                            {loadingModal ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Templates */}
                <Modal 
                    show={showModalTemplates} 
                    onHide={this.fecharModalTemplates}
                    size="xl"
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Templates HiPlatform {integracaoSelecionada && `- ${this.getProgramaNome(integracaoSelecionada.programa_id) || 'Sem programa'}`}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {templatesJsonError && (
                            <Alert variant="danger" className="py-2 mb-3">{templatesJsonError}</Alert>
                        )}
                        <Form.Group>
                            <Form.Label>Edite o JSON dos templates abaixo:</Form.Label>
                            <Editor
                                height="500px"
                                defaultLanguage="json"
                                value={templatesJson}
                                onChange={this.handleTemplatesJsonChange}
                                theme="vs-dark"
                                options={{
                                    minimap: { enabled: false },
                                    fontSize: 14,
                                    formatOnPaste: true,
                                    formatOnType: true,
                                    automaticLayout: true,
                                    tabSize: 4,
                                }}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModalTemplates}>
                            Cancelar
                        </Button>
                        <Button 
                            variant="success" 
                            onClick={this.salvarTemplates}
                            disabled={loadingModal}
                        >
                            {loadingModal ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar Templates
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ClienteIntegracaoHiPlatform;
